// extracted by mini-css-extract-plugin
export default {"modelItemLabel":"ModelItem-module__modelItemLabel--dRhq_"};